/* eslint-disable no-nested-ternary */
import {
    Button, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'appkit-react';

const DeleteFile = ({
    visible, setVisible, onSave, loading, inputTypes,
}) => {
    const containFolderAndFiles = () => (inputTypes.includes('file') && inputTypes.includes('directory'));

    const containFolders = () => (inputTypes.includes('directory'));

    const getFolderAndFileText = () => {
        let text;
        if (containFolderAndFiles()) {
            text = ' folders and files';
        } else if (containFolders()) {
            text = ' folder(s)';
        } else {
            text = ' file(s)';
        }
        return text;
    };

    return (
        <div>
            <Modal
                className="add-and-edit-modal"
                visible={visible}
                onCancel={() => { setVisible(false); }}
                style={{ marginTop: '10rem' }}
                backdropClosable={false}
            >
                <ModalHeader>
                    <div className="a-modal-header">
                        <div className="modal-title-left">
                            <div className="modal-title">
                                Delete
                                {inputTypes.length > 1 ? ' multiple ' : ''}
                                {getFolderAndFileText()}
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div>
                        <h6>
                            {`Are sure you want delete selected ${getFolderAndFileText()} ?`}
                        </h6>
                    </div>
                </ModalBody>
                <ModalFooter style={{ justifyContent: 'flex-end' }}>
                    <Button kind="secondary" onClick={() => { setVisible(false); }} size="lg"> Cancel </Button>
                    <Button kind="primary" size="lg" onClick={onSave} isLoading={loading}> Delete </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default DeleteFile;
